import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import instagramIcon from "../assets/images/instagram_blue.svg";
import "./PrivacyPolicy.css";

function CompliancePolicy() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = "U.S.C. § 2257 Record-Keeping & Compliance Policy - TLINK.ME";
    window.scrollTo(0, 0);

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="header-content">
          <div className="header-logo">
            <Link to="/" className="logo-link">
              <h1>TLINK.ME</h1>
            </Link>
          </div>
        </div>
      </header>

      <main className="privacy-content">
        <h1 className="privacy-title">
          U.S.C. § 2257 Record-Keeping &amp; Compliance Policy
        </h1>

        <h2 className="privacy-h2">1. Purpose &amp; Legal Framework</h2>
        <p className="privacy-text">
          OCAI LTD is committed to full compliance with 18 U.S.C. § 2257 and 28
          C.F.R. Part 75, which establish federal record-keeping,
          age-verification, and labeling requirements for producers of visual
          depictions of sexually explicit conduct.
        </p>
        <p className="privacy-text">
          This policy outlines the procedures OCAI LTD maintains to ensure that
          all applicable content on its platform complies with these
          requirements.
        </p>

        <h2 className="privacy-h2">2. Applicability</h2>
        <p className="privacy-text">
          OCAI LTD operates a digital platform that facilitates AI-generated and
          creator-published content distributed via Telegram. Where content
          qualifies as covered material under 18 U.S.C. § 2257, OCAI LTD ensures
          appropriate compliance measures are in place.
        </p>
        <p className="privacy-text">
          OCAI LTD acts as a secondary producer, as defined under the statute,
          and does not produce physical recordings or host content involving
          real minors.
        </p>

        <h2 className="privacy-h2">3. Age Verification &amp; Identity Confirmation</h2>
        <p className="privacy-text">To comply with § 2257 requirements:</p>
        <ul>
          <li>
            All creators must complete identity and age verification prior to
            being permitted to publish monetized content or receive payouts.
          </li>
          <li>
            Creators are required to submit valid, government-issued photo
            identification confirming they are 18 years of age or older.
          </li>
          <li>
            Identity information is reviewed to ensure authenticity and
            consistency with the creator’s account.
          </li>
        </ul>
        <p className="privacy-text">
          No creator is permitted to publish content until verification is
          successfully completed.
        </p>

        <h2 className="privacy-h2">4. Prohibition of Minors</h2>
        <p className="privacy-text">OCAI LTD strictly prohibits:</p>
        <ul>
          <li>Any content involving minors</li>
          <li>Any depiction that suggests, represents, or implies a minor</li>
          <li>Any content that violates federal or state child protection laws</li>
        </ul>
        <p className="privacy-text">
          Any violation results in immediate account termination and escalation
          in accordance with legal obligations.
        </p>

        <h2 className="privacy-h2">5. Record-Keeping Requirements</h2>
        <p className="privacy-text">In accordance with 18 U.S.C. § 2257:</p>
        <ul>
          <li>
            Records verifying the identity and age of creators are securely
            maintained.
          </li>
          <li>Records are retained for the legally required period.</li>
          <li>
            Records are stored securely with restricted access and are available
            for inspection by authorized government officials upon lawful
            request.
          </li>
        </ul>

        <h2 className="privacy-h2">6. Labeling &amp; Producer Statements</h2>
        <p className="privacy-text">
          Where applicable, OCAI LTD ensures that required § 2257 compliance
          statements are made available and that records identify:
        </p>
        <ul>
          <li>The entity responsible for record maintenance</li>
          <li>The location where records are kept</li>
        </ul>
        <p className="privacy-text">
          These disclosures are maintained internally and provided as required
          by law.
        </p>

        <h2 className="privacy-h2">7. Content Monitoring &amp; Enforcement</h2>
        <p className="privacy-text">
          OCAI LTD supplements record-keeping obligations with:
        </p>
        <ul>
          <li>Ongoing content moderation</li>
          <li>Automated and manual review processes</li>
          <li>Immediate enforcement actions for policy violations</li>
        </ul>
        <p className="privacy-text">
          Content or accounts that raise compliance concerns are suspended
          pending investigation.
        </p>

        <h2 className="privacy-h2">8. Cooperation with Authorities</h2>
        <p className="privacy-text">
          OCAI LTD cooperates fully with lawful requests from U.S. and
          international authorities related to § 2257 compliance, child
          protection, and related matters.
        </p>

        <h2 className="privacy-h2">9. Policy Review</h2>
        <p className="privacy-text">
          This policy is reviewed periodically and updated to reflect changes
          in law, regulatory guidance, or platform operations.
        </p>

        <div className="policy-navigation">
          <h3 className="policy-nav-title">Other Policies</h3>
          <div className="policy-nav-links">
            <Link to="/privacy-policy" className="policy-nav-link">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="policy-nav-link">
              Terms & Conditions
            </Link>
            <Link to="/pii-policy" className="policy-nav-link">
              PII Policy
            </Link>
          </div>
        </div>
      </main>

      <footer className="privacy-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span className="footer-title">FOLLOW US</span>
            <div className="footer-social">
              <img
                src={instagramIcon}
                alt="Instagram"
                className="footer-instagram-icon"
              />
              <a
                href="https://instagram.com/tlink.me"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-handle"
              >
                TLINK.ME
              </a>
            </div>
          </div>
          <div className="footer-center">
            <div className="footer-logo">TLINK.ME</div>
          </div>
          <div className="footer-right">
            <div className="footer-copyright">
              ALL RIGHTS RESERVED.
              <span className="footer-year">2025</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CompliancePolicy;
